import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';

export default class HotelStandard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pristine: true,
      values: [0, 1, 2, 3, 4, 5],
      hotel_standard: 0
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.rating_min != 'undefined' && this.state.pristine) {
      this.setState({ hotel_standard: nextProps.rating_min, pristine: false });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => (
    <div
      className={
        'hotel_standard select-wrapper animated-text-form extended ' +
        (this.state.active ? 'active' : '')
      }
      ref={() => {
        this.returnSearchedValue = this.returnSearchedValue.bind(this);
      }}
    >
      <label className="animated-text-label" htmlFor="stars">
        <span className="animated-text-label-name">{this.props.title}</span>
      </label>
      <span
        className={`stars stars-${this.state.hotel_standard} input-stars`}
      />
      <i className="dropdown-icon fa fa-chevron-down" />
      <input
        id="stars"
        type="text"
        value=""
        className="animated-text-input stars-input"
        readOnly
        onFocus={this.handleFocus}
      />
      <div className="dropdown-menu">
        {this.props.withMobileTitle && (
          <h5 className="with-mobile-title">{this.props.title}</h5>
        )}
        <i className="fa fa-times close-icon" onClick={this.handleClose} />
        <ul className="dropdown-wrapper">{this.renderCheckboxes()}</ul>
      </div>
    </div>
  );

  stopEventBehaviour(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
      this.stopEventBehaviour(event);
    }
  };

  handleChange = event =>
    this.setState({ hotel_standard: event.target.value, active: false });

  handleClose = () => this.setState({ active: false });

  handleFocus = () => {
    this.setState({ active: true });
  };

  renderCheckboxes = () => {
    return this.state.values.map((standard, i) => {
      const isChecked = this.state.hotel_standard == `${standard}`;
      return (
        <li key={`hotel_standard ${i}`} className="item">
          <input
            type="radio"
            id={'hotel_standard' + i}
            name="hotel_standard"
            onChange={this.handleChange}
            value={standard}
            checked={isChecked}
          />
          <label htmlFor={'hotel_standard' + i}>
            {(standard != 0 && (
              <span className={`stars stars-${standard}`} />
            )) || <span>{T('filters_any')}</span>}
          </label>
        </li>
      );
    });
  };

  returnSearchedValue = () =>
    this.state.hotel_standard !== 0 ? this.state.hotel_standard : false;
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/hotel_standard.js